/* Home photo gallery (2026-10-16): the sideways photo collage glides by itself in an endless loop.
   Smoothness: the row is moved with a CSS transform animation (sub-pixel, on the graphics card) instead of changing
   scrollLeft, which can only move in whole pixels and therefore looks jerky at slow speeds.
   The photo cards are copied once (aria-hidden); the animation moves the row by exactly one set, then starts again,
   which is invisible. Speed = pixels per second (theme editor, 0 = off). Paused while the section is off screen;
   not animated at all for reduced motion (then the row stays a normal swipeable row). */
(function () {
  'use strict';
  document.querySelectorAll('[data-hv-gallery]').forEach(function (root) {
    var rail = root.querySelector('[data-gal-rail]');
    if (!rail) return;
    var items = Array.prototype.slice.call(rail.children);
    if (items.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = Number(root.getAttribute('data-speed'));
    if (isNaN(speed)) speed = 40;
    if (!speed || reduce) return;

    items.forEach(function (li) {
      var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      c.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
      rail.appendChild(c);
    });

    function measure() {
      var loop = rail.children[items.length].offsetLeft - rail.children[0].offsetLeft;
      if (loop <= 0) return;
      rail.style.setProperty('--hv-loop', loop + 'px');
      rail.style.setProperty('--hv-dur', (loop / speed).toFixed(1) + 's');
    }
    measure();
    rail.classList.add('is-gliding');
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(measure, 200); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { rail.classList.toggle('is-off', !en[0].isIntersecting); }, { threshold: 0 }).observe(rail);
    }
  });
})();
